<!-- 添加商品 -->
<template>
  <div>
    <d-product></d-product>
  </div>
</template>

<script>
import dProduct from "@Components/public/dProduct"
export default {
  data () {
    return {
    };
  },

  components: {
    dProduct,
  }
}
</script>
<style lang= "scss" scoped>
</style>